import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { PaneListButton } from "src/components/PaneListButton";
import { EmissionListItemIcon } from "src/components/EmissionListItemIcon";
import { Emission, EmissionType, Scenario } from "src/types";
import { UnknownEmissionTypeError } from "src/errors";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { isDisabled, isEnabled } from "src/utils/permission.utils";

export function EmissionListItem(props: { caseId: string; scenario: Scenario; emission: Emission }) {
  const { emission, caseId, scenario } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  /**
   * Functions
   */
  function handleOpenMenu(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  }
  function handleCloseMenu(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(null);
  }
  function handleOpenImport(event: React.MouseEvent<any>) {
    event.stopPropagation();
    event.preventDefault();

    if (isEnabled(scenario.permissions.updateEmission)) {
      const importPath = `${emissionPath(caseId, scenario.id, emission)}/import`;
      navigate(importPath);
      setAnchorEl(null);
    }
  }

  return render();

  function render() {
    return (
      <PaneListButton to={emissionPath(caseId, scenario.id, emission)}>
        <EmissionListItemIcon type={emission.type} />
        <div className="name">{t(`label.emissionType.${emission.type}`)}</div>

        <Box flexGrow={1} />
        <IconButton onMouseDown={(event) => event.stopPropagation()} onClick={handleOpenMenu} size="large">
          <MoreVertIcon fontSize="small" />
        </IconButton>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
          <MenuItem onClick={handleOpenImport} disabled={isDisabled(scenario.permissions.updateEmission)}>
            {t("label.bulkUpload")}
          </MenuItem>
        </Menu>
      </PaneListButton>
    );
  }
}

function emissionPath(caseId: string, scenarioId: string | number, emission: Emission) {
  if (emission.type === EmissionType.TRAFFIC) {
    return `/cases/${caseId}/scenarios/${scenarioId}/emissions/traffic/${emission.id}`;
  } else if (emission.type === EmissionType.POINT_SOURCE) {
    return `/cases/${caseId}/scenarios/${scenarioId}/emissions/point-source/${emission.id}`;
  } else {
    throw UnknownEmissionTypeError(emission.type);
  }
}
